module.exports = __webpack_public_path__ + "static/about_pic-83991bf1623e448124c41ede9e35fef3.png";